var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5823 8.25C50.27 8.25 53.8175 9.7075 56.4272 12.3227C59.0397 14.9325 60.5 18.4525 60.5 22.1375V43.8625C60.5 51.535 54.2575 57.75 46.5823 57.75H19.415C11.7398 57.75 5.5 51.535 5.5 43.8625V22.1375C5.5 14.465 11.7122 8.25 19.415 8.25H46.5823ZM49.6925 22.55C49.115 22.5197 48.565 22.715 48.1497 23.1L35.75 33C34.155 34.3228 31.8697 34.3228 30.25 33L17.875 23.1C17.0198 22.4675 15.8373 22.55 15.125 23.2925C14.3825 24.035 14.3 25.2175 14.9297 26.0425L15.29 26.4L27.8025 36.1625C29.3425 37.3725 31.2098 38.0325 33.165 38.0325C35.1148 38.0325 37.015 37.3725 38.5523 36.1625L50.9575 26.235L51.1775 26.015C51.8348 25.2175 51.8348 24.0625 51.1473 23.265C50.765 22.8553 50.2397 22.605 49.6925 22.55Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.d4a9b9383eb8bd0d203febd27481db84.svg";
export { ForwardRef as ReactComponent };